import { PERMISSIONS } from "../../../../../../../shared/guard/Permissions";

export interface MenuItem {
  title: string;
  path?: string;
  permission: PERMISSIONS;
  queryString: string;
}

const normalizeTitle = (title: string) => {
  return title.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\s+/g, '');
};

const MenuItems: MenuItem[] = [
  { title: "Indicadores", queryString: normalizeTitle("Indicadores"), permission: PERMISSIONS.VISUALIZAR_INDICADORES },
  { title: "Dashboard", queryString: normalizeTitle("Dashboard"), permission: PERMISSIONS.VISUALIZAR_DASHBOARD },
];

export default MenuItems;
